<script>
import validation from "@/components/Utility/Validation"

const PARAM = [
  {
    form_section: 'Personal Profile',
  },
  {
    key: 'name',
    text: 'Personal Full Name *',
  },
  {
    key: 'nationality',
    text: 'Nationality *',
    form_select: [
      'Malaysian',
      'Non-Malaysian',
    ],
  },
  {
    key: 'nationalID',
    text: 'NIRC / Passport No. *',
  },
  {
    key: 'personalEmail',
    text: 'Email *',
    form_email: true,
    form_input_validation: [
      validation.validateRequire,
      validation.validateEmail,
    ],
    form_muted: function() {
      if(window.location.href.includes('personalForm')) {
        return 'This email address is use as Login ID and monthly season parking e-Billing.';
      }
    }
  },
  {
    key: 'personalPhoneMobile',
    text: 'Phone No. (Mobile) *',
    form_phone: true,
    form_input_validation: [
      validation.validateRequire,
      validation.validatePhone
    ],
  },
  {
    key: 'personalPhoneResidential',
    text: 'Phone No. (Residential)',
    form_phone: true,
    form_input_validation: [
      validation.validatePhone
    ],
  },
  {
    form_section: 'Correspondence Address',
  },
  {
    key: 'personalCorrespondenceAddress1',
    text: 'Address 1 *',
  },
  {
    key: 'personalCorrespondenceAddress2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'personalCorrespondenceAddress3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'personalCorrespondenceAddressPostalCode',
    text: 'Postal Code *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'personalCorrespondenceAddressCityID',
    text: 'City *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'personalCorrespondenceAddressStateID',
    text: 'State *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'personalCorrespondenceAddressCountryID',
    text: 'Country *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    form_section: 'Permanent Address',
  },
  {
    key: '_sameAsCorrespondenceAddress',
    text: 'Same as correspondence address',
    form_checkbox: true,
    form_input_validation: [],
  },
  {
    key: 'personalPermanentAddress1',
    text: 'Address 1 *',
  },
  {
    key: 'personalPermanentAddress2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'personalPermanentAddress3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'personalPermanentAddressPostalCode',
    text: 'Postal Code *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'personalPermanentAddressCityID',
    text: 'City *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'personalPermanentAddressStateID',
    text: 'State *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'personalPermanentAddressCountryID',
    text: 'Country *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    form_section: 'Emergency Contact',
  },
  {
    key: 'emergencyName',
    text: 'Emergency Contact Name',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'emergencyRelationship',
    text: 'Relationship',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'emegencyPhoneResidential',
    text: 'Emergency Phone No. (Residential)',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validatePhone
    ],
  },
  {
    key: 'emegencyPhoneOffice',
    text: 'Emergency Phone No. (Office)',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validatePhone
    ],
  },
  {
    key: 'emegencyPhoneMobile',
    text: 'Emergency Phone No. (Mobile)',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validatePhone
    ],
  },
  {
    form_section: 'Company Information',
  },
  {
    key: 'companyName',
    text: 'Company Name *',
  },
  {
    key: 'companyNationalID',
    text: 'Company Reg. No. *',
    form_input_attr: {
      'placeholder': 'E.g. 824592D',
    },
    form_input_validation: [
      validation.validateRequire,
      function(value, inputParameter) {
        // var re = /^[A-Z0-9]*$/;
        var re = /^[^a-z]*$/;
        if(!re.test(value)) {
          return 'Company Reg. No. must consist of capital letter, numbers and symbol only';
        }
      },
    ],
    form_muted: function() {
      if(window.location.href.includes('personalForm')) {
        return 'Use capital letters and numbers only.'
      }
    }
  },
  {
    form_section: 'Company Address',
  },
  {
    key: 'companyAddress1',
    text: 'Address 1 *',
  },
  {
    key: 'companyAddress2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'companyAddress3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'companyAddressPostalCode',
    text: 'Postal Code *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'companyAddressCityID',
    text: 'City *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'companyAddressStateID',
    text: 'State *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'companyAddressCountryID',
    text: 'Country *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    form_section: 'Company Contact',
  },
  {
    key: 'companyTelephone',
    text: 'Company Telephone No',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validatePhone
    ],
  },
  {
    key: 'companyPICname',
    text: 'Company PIC Name *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'companyPICphone',
    text: 'Company PIC Phone (Mobile) *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validateRequire,
      validation.validatePhone
    ],
  },
  {
    key: 'companyPICemail',
    text: 'Company PIC Email *',
    form_email: true,
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [
      validation.validateRequire,
      validation.validateEmail,
    ],
  },
];

let getParam = function(displayOnly) {
  const PERSONAL_PARAM = $.extend(true, [], PARAM);
  if(displayOnly) {
    PERSONAL_PARAM.forEach((k, j) => {
      k['form_input_attr'] = k['form_input_attr'] || {};
      k['form_input_attr'].disabled = true;
      k['form_hide'] = k['key'] === '_sameAsCorrespondenceAddress';
    });
  }
  return PERSONAL_PARAM;
}

export default {
  getParam,
}

</script>


// WEBPACK FOOTER //
// src/components/Param/CustomerPersonalParam.vue